import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'csi-expanded-card',
  templateUrl: './expanded-card.modal.html',
  styleUrls: ['./expanded-card.modal.scss']
})
export class ExpandedCardModal implements OnInit {
  card = this.data as any;
  public readonly translocoFileKey = 'dashboard.';

  constructor(
    public dialogRef: MatDialogRef<ExpandedCardModal>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  columnDefs = [];

  page = 0;

  pageSize = 15;

  maxPages = 1;

  slicedData = [];

  displayedContent = [];

  ngOnInit() {
    this.page = 0;
    if (this.card.expandedContent) {
      this.columnDefs = (this.card.expandedContent || []).map(col => col.heading);
      this.displayedContent = this.card.expandedContent;
    } else {
      this.columnDefs = (this.card.content || []).map(col => col.heading);
      this.displayedContent = this.card.content;
    }
    this.slicedData = this.chunkArray(this.card.data, this.pageSize);
    this.maxPages = this.slicedData.length - 1;
  }

  chunkArray<T>(arr: T[], size: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  }

  onRowClick(row: any) {
    if (this.card.clickable && typeof this.card.clickable.action === 'function') {
      this.card.clickable.action(row);
    }
    this.dialogRef.close();
  }

  nextPage() {
    this.page++;
  }

  prevPage() {
    this.page--;
  }

  public static open(matDialogService: MatDialog, card: any) {
    return matDialogService.open(ExpandedCardModal, {
      data: card
    });
  }
}
